import React, { useEffect, useState, useRef } from "react";
import { UrlApi } from "../../../services/apirest";
import { getData, putData, postData } from "../../../services/library";
import {
  IconButton,
  Button,
  Grid,
  Container,
  TextField,
  Tooltip,
  Box,
  Typography,
  Autocomplete,
  Stack,
} from "@mui/material";
import moment from "moment";
import Notify from "../../Notify";
import Title from "../../Title";

//Iconos para los textfields
import InputAdornment from "@mui/material/InputAdornment";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

// ICONOS
import TimeToLeaveIcon from "@mui/icons-material/TimeToLeave";
import EightteenMpIcon from "@mui/icons-material/EightteenMp";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import Battery50Icon from "@mui/icons-material/Battery50";
import AddBoxIcon from "@mui/icons-material/AddBox";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import CircularProgress from "@mui/material/CircularProgress";

// COMPONENTES
import AddMarcaVehiculo from "../../vehiculos_nuevo/add/AddMarcaVehiculo";
import AddModeloVehiculo from "../../vehiculos_nuevo/add/AddModeloVehiculo";
import Addchofer from "../choferes/AddChofer";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Editarvehiculos(props) {
  const [datosVehiculo, setDatosVehiculo] = useState(props.datos);


  // ********** AGREGADO DE MARCA Y MODELO ********//
  const [tabla, setTabla] = useState(true);
  const [altaMarca, setAltaMarca] = useState(false);
  const [altaModelo, setAltaModelo] = useState(false);
  const [altachofer, setAltachofer] = useState(false); //Estado para abrir alta chofer
  const [actualizar, setActualizar] = useState(false);
  const [marcas, setMarcas] = useState();
  const [marcaSeleccionada, setMarcaSeleccionada] = useState("");
  const [modelos, setModelos] = useState();
  const [modeloSeleccionado, setModeloSeleccionado] = useState("");
  // const [buscando, setBuscando] = useState(false);
  const [tipoVehiculo, setTipoVehiculo] = useState(null);
  const [choferes, setChoferes] = useState(null);
  const [uso, setUso] = useState(null);
  const [sucursales, setSucursales] = useState(null);
  const [transportistas, settransportistas] = useState(null);
  const [duenio, setduenio] = useState(null);
  const [choferSeleccionado, setChoferSeleccionado] = useState("");
  const [usoSeleccionado, setUsoSeleccionado] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [transportistaSeleccionada, setTransportistaSeleccionada] =
    useState("");
  const [tipoSeleccionado, setTipoSeleccionado] = useState("");
  const [duenioSeleccionado, setDuenioSeleccionado] = useState("");

  const obtenerMarcas = () => {
    fetch(UrlApi + "/marcas/")
      .then((data) => data.json())
      .then((data) => setMarcas(data));
  };

  useEffect(() => {
    obtenerMarcas();
  }, [tabla]);

  //agregue este efecto para acutlizar el listado de choferes si lo agregan desde addvehiculos
  useEffect(() => {
    if (actualizar) {
      getData("/choferes", setChoferes);
    }
  }, [actualizar]);

  const obtenerModelos = () => {
    // setBuscando(true);
    fetch(UrlApi + "/modelos/xmarca/" + marcaSeleccionada.id)
      .then((data) => data.json())
      .then((data) => setModelos(data))
      .then((data) => setModeloSeleccionado(""));
    // .then((data) => setBuscando(false));
  };

  // const obtenerVtv = () => {
  //   fetch(UrlApi + "/desplegables/vencimientos/vtv")
  //     .then((data) => data.json())
  //     .then((data) => setVtv(data));
  // };

  // const obtenerSeguro = () => {
  //   fetch(UrlApi + "/desplegables/vencimientos/seguro")
  //     .then((data) => data.json())
  //     .then((data) => setSeguro(data));
  // };

  useEffect(() => {
    obtenerModelos();
  }, [marcaSeleccionada]);

  const handleClickMarca = () => {
    setAltaMarca(true);
    setTabla(false);
  };

  const handleClickModelo = (row) => {
    setAltaModelo(true);
    setTabla(false);
  };

  const handleClickchofer = (row) => {
    setAltachofer(true);
    setTabla(false);
  };

  const [vencimientos, setVencimientos] = useState([]);
  // console.log("datosVehiculo.idve", datosVehiculo.idvehiculo);
  

  const obtenerVencimientos = () => {
    fetch(UrlApi + "/vehiculos_vencimientos/" + datosVehiculo.uuid_vehiculo)
      .then((data) => data.json())
      .then((data) => setVencimientos(data));
  };

  console.log("vencimientos", vencimientos);
  

  useEffect(() => {
    obtenerVencimientos();
  }, [tipoSeleccionado]);

  //******** Cambio de modelo seleccionado *******//
  useEffect(() => {
    if (datosVehiculo.id_marca !== null && marcas) {
      const marcaEncontrada = marcas.find(
        (d) => d.id === datosVehiculo.id_marca
      );
      if (marcaEncontrada) {
        setMarcaSeleccionada(marcaEncontrada);
      }
    }
  }, [datosVehiculo, marcas]);

  useEffect(() => {
    if (modelos && datosVehiculo.id_modelo !== null) {
      const modeloEncontrado = modelos.find(
        (d) => d.id === datosVehiculo.id_modelo
      );
      if (modeloEncontrado) {
        setModeloSeleccionado(modeloEncontrado);
      }
    }
  }, [modelos]);

  useEffect(() => {
    if (choferes && datosVehiculo.id_chofer !== null) {
      const choferEncontrado = choferes.find(
        (d) => d.id === datosVehiculo.id_chofer
      );
      if (choferEncontrado) {
        setChoferSeleccionado(choferEncontrado);
      }
    }
  }, [choferes]);

  useEffect(() => {
    if (uso && datosVehiculo.uso !== null) {
      const usoEncontrado = uso.find((d) => d.id === datosVehiculo.uso);
      if (usoEncontrado) {
        setUsoSeleccionado(usoEncontrado);
      }
    }
  }, [uso]);

  useEffect(() => {
    if (sucursales && datosVehiculo.id_sucursal !== null) {
      const sucursalEncontrada = sucursales.find(
        (d) => d.id === datosVehiculo.id_sucursal
      );
      if (sucursalEncontrada) {
        setSucursalSeleccionada(sucursalEncontrada);
      }
    }
  }, [sucursales]);

  useEffect(() => {
    if (duenio && datosVehiculo.duenio !== null) {
      const duenioEncontrado = duenio.find(
        (d) => d.id === datosVehiculo.duenio
      );
      if (duenioEncontrado) {
        setDuenioSeleccionado(duenioEncontrado);
      }
    }
  }, [duenio]);

  useEffect(() => {
    if (transportistas && datosVehiculo.id_transportista !== null) {
      const transportistaEncontrada = transportistas.find(
        (d) => d.id_transportista === datosVehiculo.id_transportista
      );
      if (transportistaEncontrada) {
        setTransportistaSeleccionada(transportistaEncontrada);
      }
    }
  }, [transportistas]);

  useEffect(() => {
    if (tipoVehiculo && datosVehiculo.id_tipo !== null) {
      const tipoEncontrado = tipoVehiculo.find(
        (d) => d.id === datosVehiculo.id_tipo
      );
      if (tipoEncontrado) {
        setTipoSeleccionado(tipoEncontrado);
      }
    }
  }, [tipoVehiculo]);

  //**********************************************//

  // ---- Notificaciones / snackbar ----
  const [notificacion, setNotificacion] = useState({ tipo: "", mensaje: "" });
  const [openSnack, setOpenSnack] = useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("success"); // "success" | "error" | "info"
  const [autoHide, setAutoHide] = useState(2000);

  // ---- Colores según estado ----
  const colorMap = {
    success: "#DFF2D8", // verde
    error: "#F8D7DA", // rojo
    info: "#FFF3CD", // amarillo
  };

  // ---- Cuando cambie `notificacion` abre el snackbar ----
  useEffect(() => {
    if (!notificacion || !notificacion.tipo) return;

    const tipo = notificacion.tipo; // "success" | "error" | "info"
    setMensaje(notificacion.mensaje || "");
    setSeverity(
      tipo === "error" ? "error" : tipo === "info" ? "info" : "success"
    );
    setColorMensaje(colorMap[tipo] || colorMap.info);

    // Si es error, no auto-hide
    // Si es success, dura 2000ms y cierra el modal (handleClose).
    // Si es info, dura 3000ms.
    if (tipo === "error") setAutoHide(null);
    else if (tipo === "success") setAutoHide(2000);
    else setAutoHide(3000);

    setOpenSnack(true);
  }, [notificacion]);

  // ---- handler para cerrar el snackbar ----
  const handleCloseSnack = (event, reason) => {
    // No cierra por clickaway
    if (reason === "clickaway") return;

    // Si el cierre fue por timeout y es success, cierra el componente
    if (reason === "timeout" && severity === "success") {
      setOpenSnack(false);
      setNotificacion({ tipo: "", mensaje: "" });
      // Cerrar el componente
      handleClose();
      return;
    }

    // Para cualquier otro cierre, solo se cierra el snackbar
    setOpenSnack(false);
    setNotificacion({ tipo: "", mensaje: "" });
  };

  //**********************************************//

  const [disBtn, setDisbtn] = useState(false);

  useEffect(() => {
    // CAMBIO A LA OBTENCION DE TIPO VEHICULOS
    // getData("/desplegables/tipovehiculos", setTipoVehiculo);

    // NUEVO OBTENER DESDE TABLA tipovehiculos
    // getData("/tipos_vehiculos/activos", setTipoVehiculo);
    getData("/tipos_vehiculos2/activos", setTipoVehiculo);
    //

    getData("/choferes", setChoferes);
    getData("/desplegables/usoVehiculo", setUso);
    getData("/sucursales", setSucursales);
    getData("/desplegables/dueniovehiculo", setduenio);
    getData("/transportistas", settransportistas);
  }, []);

  //FIN CONSULTAS A LA API-----------------------------

  //funcion para guardar
  const guardarVehiculos = (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    setDisbtn(true);

    // Payload para actualizar vehículo
    const payloadVehiculo = {
      id_sisven: datosVehiculo.id_sisven,
      id_sisven_autogas:datosVehiculo.id_sisven_autogas,
      marca: datosVehiculo.marca,
      modelo: datosVehiculo.modelo,
      capacidad: datosVehiculo.capacidad,
      patente: datosVehiculo.patente,
      id_tipo: tipoSeleccionado?.id || null,
      id_chofer:
        tipoSeleccionado &&
        (tipoSeleccionado.id === 64 || tipoSeleccionado.id === 268)
          ? null
          : choferSeleccionado?.id ?? null,
      vencimientovtv: datosVehiculo.vencimientovtv
        ? moment(datosVehiculo.vencimientovtv).format("YYYY-MM-DD")
        : null,
      vencimientohidraulica: datosVehiculo.vencimientohidraulica
        ? moment(datosVehiculo.vencimientohidraulica).format("YYYY-MM-DD")
        : null,
      tara: datosVehiculo.tara,
      uso: usoSeleccionado?.id || null,
      ltstkcombustible: datosVehiculo.ltstkcombustible,
      id_sucursal: sucursalSeleccionada?.id || null,
      usuario: localStorage.getItem("user"),
      capacidadtotalm3: datosVehiculo.capacidadtotalm3,
      t1: datosVehiculo.t1,
      duenio: duenioSeleccionado?.id || null,
      id_transportista: transportistaSeleccionada?.id_transportista || null,
      id_modelo: modeloSeleccionado?.id || null,
      nro_motor: datosVehiculo.nro_motor,
      nro_chasis: datosVehiculo.nro_chasis,
      vtv_tipo_vencimiento: datosVehiculo.vtv_tipo_vencimiento || null,
      oblea_matafuegos_fecha_vencimiento:
        datosVehiculo.oblea_matafuegos_fecha_vencimiento
          ? moment(datosVehiculo.oblea_matafuegos_fecha_vencimiento).format(
              "YYYY-MM-DD"
            )
          : null,
      seguro_fecha_vencimiento: datosVehiculo.seguro_fecha_vencimiento
        ? moment(datosVehiculo.seguro_fecha_vencimiento).format("YYYY-MM-DD")
        : null,
      seguro_tipo_seguro: datosVehiculo.seguro_tipo_seguro || null,
      fecha_vto_revision_quincenal: datosVehiculo.fecha_vto_revision_quincenal
        ? moment(datosVehiculo.fecha_vto_revision_quincenal).format(
            "YYYY-MM-DD"
          )
        : null,
      fecha_vto_revision_valvula_seguridad:
        datosVehiculo.fecha_vto_revision_valvula_seguridad
          ? moment(datosVehiculo.fecha_vto_revision_valvula_seguridad).format(
              "YYYY-MM-DD"
            )
          : null,
      fecha_vto_revision_valvula_exceso:
        datosVehiculo.fecha_vto_revision_valvula_exceso
          ? moment(datosVehiculo.fecha_vto_revision_valvula_exceso).format(
              "YYYY-MM-DD"
            )
          : null,
      fecha_vto_revision_mangueras: datosVehiculo.fecha_vto_revision_mangueras
        ? moment(datosVehiculo.fecha_vto_revision_mangueras).format(
            "YYYY-MM-DD"
          )
        : null,
      fecha_vto_matafuegos_dos: datosVehiculo.fecha_vto_matafuegos_dos
        ? moment(datosVehiculo.fecha_vto_matafuegos_dos).format("YYYY-MM-DD")
        : null,
    };

    // Actualizar el vehículo (PUT)
    putData(
      e,
      `/vehiculos/${datosVehiculo.idvehiculo}`,
      payloadVehiculo,
      () => {
        // On success -> manejar vencimientos
        (async () => {
          try {
            const uuidVehiculo =
              datosVehiculo.uuid_vehiculo ??
              vencimientos?.[0]?.uuid_vehiculo ??
              null;

            const toUpdate = [];
            const toInsert = [];

            // Listas de updates / inserts
            componentes.forEach((comp) => {
              const keyBase = comp.componente
                .toLowerCase()
                .replace(/\s+/g, "_");
              const fieldName = `vencimiento_${keyBase}`;

              const existing = vencimientos.find(
                (v) => Number(v.id_componente) === Number(comp.id_componente)
              );

              const existingFmt =
                existing && existing.vencimiento
                  ? moment(existing.vencimiento).format("YYYY-MM-DD")
                  : null;

              const fieldPresente = Object.prototype.hasOwnProperty.call(
                datosVehiculo,
                fieldName
              );

              if (fieldPresente) {
                const raw = datosVehiculo[fieldName];
                const newFmt = raw ? moment(raw).format("YYYY-MM-DD") : null;

                if (existing) {
                  if (existingFmt !== newFmt) {
                    toUpdate.push({ id: existing.id, vencimiento: newFmt });
                  }
                } else {
                  if (newFmt) {
                    toInsert.push({
                      uuid_vehiculo: uuidVehiculo,
                      id_componente: comp.id_componente,
                      vencimiento: newFmt,
                    });
                  }
                }
              }
            });

            // Calculo de vencimientos a eliminar
            const componentesIdsActuales = new Set(
              (componentes || []).map((c) => Number(c.id_componente))
            );

            const toDelete = (vencimientos || [])
              .filter(
                (v) => !componentesIdsActuales.has(Number(v.id_componente))
              )
              .map((v) => ({ id: v.id }));

            // Ejecutar PUT
            if (toUpdate.length > 0) {
              await Promise.all(
                toUpdate.map(
                  (u) =>
                    new Promise((resolve, reject) => {
                      putData(
                        e,
                        `/vehiculos_vencimientos/${u.id}`,
                        { vencimiento: u.vencimiento },
                        () => resolve(),
                        (err) => reject(err)
                      );
                    })
                )
              );
            }

            // Ejecutar DELETE
            if (toDelete.length > 0) {
              await Promise.all(
                toDelete.map(
                  (d) =>
                    new Promise((resolve, reject) => {
                      fetch(`${UrlApi}/vehiculos_vencimientos/${d.id}`, {
                        method: "DELETE",
                        headers: { "Content-Type": "application/json" },
                      })
                        .then((res) => {
                          if (!res.ok)
                            return res.text().then((t) => Promise.reject(t));
                          resolve();
                        })
                        .catch((err) => reject(err));
                    })
                )
              );
            }

            // Ejecutar POST
            if (toInsert.length > 0) {
              await new Promise((resolve, reject) => {
                postData(
                  e,
                  "/vehiculos_vencimientos",
                  { vencimientos: toInsert },
                  (res) => resolve(res),
                  (err) => reject(err)
                );
              });
            }

            // Notificación todo OK
            setNotificacion({
              tipo: "success",
              mensaje:
                toUpdate.length === 0 &&
                toInsert.length === 0 &&
                toDelete.length === 0
                  ? "Vehículo actualizado correctamente. No hubo cambios en vencimientos."
                  : "Vehículo y vencimientos actualizados correctamente.",
            });
            setDisbtn(false);
          } catch (err) {
            console.error("Error actualizando vencimientos:", err);
            setNotificacion({
              tipo: "error",
              mensaje:
                (err && err.message) ||
                "Ocurrió un error al actualizar los vencimientos. Verifique y reintente.",
            });
            setDisbtn(false);
          }
        })();
      },
      (err) => {
        // Error actualizando vehículo
        setNotificacion({
          tipo: "error",
          mensaje:
            (err && err.message) ||
            "Ocurrió un error al actualizar el vehículo. Verifique los datos y reintente.",
        });
        setDisbtn(false);
      }
    );
  };

  const almacenar = (e) => {
    const { name, value } = e.target;
    setDatosVehiculo((prev) => ({
      ...prev,
      [name]: value === "" ? null : value,
    }));
  };

  const handleClose = () => {
    props.tabla(true);
    props.editar(false);
  };

  // *********************************************************************

  // Cuando el tipo seleccionado no requiera chofer, limpio el select
  useEffect(() => {
    if (tipoSeleccionado?.requiere_chofer === 0) {
      // limpia valor del "Autocomplete"
      setChoferSeleccionado(null);

      // Dejo el "id_chofer" en null
      setDatosVehiculo((prev) => ({
        ...prev,
        id_chofer: null,
      }));
    }
  }, [tipoSeleccionado]);

  // *********************************************************************

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const [error, setError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  // ********************************************************************

  const [componentes, setComponentes] = useState([]);

  const obtenerComponentes = () => {
    fetch(
      UrlApi + "/relacion_tiposv_componentes/activos/" + tipoSeleccionado.id
    )
      .then((data) => data.json())
      .then((data) => setComponentes(data));
  };

  useEffect(() => {
    obtenerComponentes();
  }, [tipoSeleccionado]);

  // ********************************************************************

  const prevHabilitadoRef = useRef(null);

  useEffect(() => {
    const habilitado =
      tipoSeleccionado &&
      usoSeleccionado &&
      tipoSeleccionado.es_t1 === 1 &&
      usoSeleccionado.id === 66;

    const prev = prevHabilitadoRef.current;

    if (prev === null) {
      // Al abrir solo se inicializa "prev"
      prevHabilitadoRef.current = habilitado;
      return;
    }

    // Si se deshabilita el check de T1, se coloca en 0 su valor
    if (!habilitado && prev) {
      setDatosVehiculo((prevState) =>
        prevState.t1 === 1 ? { ...prevState, t1: 0 } : prevState
      );
    }

    prevHabilitadoRef.current = habilitado;
  }, [tipoSeleccionado, usoSeleccionado]);

  return (
    <>
      {tabla ? (
        <Container>
          {notificacion && notificacion.open ? (
            <Notify
              mensaje={notificacion.mensaje}
              open={notificacion.open}
              color={notificacion.color}
              handleClose={handleClose}
              severity={notificacion.severity}
            />
          ) : null}
          <Title titulo="Editar Vehículo" handleClose={handleClose} />
          <form onSubmit={guardarVehiculos} autoComplete="off">
            <Box
              mt={2}
              mb={3}
              p={2}
              border={0.5}
              borderRadius={4}
              backgroundColor="#F4F6F6"
              borderColor={"#ABB2B9"}
            >
              <Grid container spacing={2} style={{ padding: 10 }}>
                <Grid item xs={1.5}>
                  <TextField
                    placeholder="ID HIPERGAS"
                    required
                    focused
                    color="primary"
                    size="small"
                    style={style}
                    name="id_sisven"
                    label="ID Sisven Hipergas"
                    type="text"
                    value={datosVehiculo.id_sisven}
                    onChange={almacenar}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 7,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MeetingRoomIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={1.5}>
                  <TextField
                    placeholder="ID AUTOGAS"
                    required
                    focused
                    color="primary"
                    size="small"
                    style={style}
                    name="id_sisven_autogas"
                    label="ID Sisven AUTOGAS"
                    type="text"
                    value={datosVehiculo.id_sisven_autogas}
                    onChange={almacenar}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 7,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MeetingRoomIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* AGREGADO DE MARCA Y MODELO */}
                <Grid item xs={3}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Autocomplete
                      fullWidth
                      options={marcas || []}
                      loading={!marcas}
                      disabled={!marcas}
                      size="small"
                      focused
                      disableClearable
                      autoHighlight
                      noOptionsText={"Marca INEXISTENTE"}
                      getOptionLabel={(m) => m.descripcion}
                      value={marcaSeleccionada || null}
                      defaultValue={marcaSeleccionada || null}
                      onChange={(event, value) => {
                        setMarcaSeleccionada(value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          style={style}
                          required
                          focused
                          size="small"
                          placeholder="Tipee para buscar..."
                          {...params}
                          label="Marca"
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <InputAdornment position="start">
                                <TimeToLeaveIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <>
                                {!marcas ? (
                                  <CircularProgress size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.descripcion}
                        </Box>
                      )}
                      sx={{ flexGrow: 1 }}
                    />
                    <Tooltip title="Agregar Marca">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleClickMarca()}
                      >
                        <AddBoxIcon />
                      </IconButton>
                    </Tooltip>{" "}
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {Object.keys(marcaSeleccionada).length === 0 ? (
                      <TextField
                        disabled
                        focused
                        fullWidth
                        size="small"
                        label="Modelo"
                      />
                    ) : (
                      <Autocomplete
                        disabled={!modelos}
                        loading={!modelos}
                        options={modelos || []}
                        size="small"
                        focused
                        disableClearable
                        noOptionsText={"Modelo INEXISTENTE"}
                        autoHighlight
                        loadingText="Buscando modelos..."
                        isOptionEqualToValue={(option, value) =>
                          option.id === value?.id
                        }
                        getOptionLabel={(m) => `${m.descripcion}`}
                        value={modeloSeleccionado || null}
                        onChange={(event, value) =>
                          setModeloSeleccionado(value)
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            key={option.id}
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.descripcion}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            style={style}
                            required
                            focused
                            size="small"
                            placeholder="Tipee para buscar..."
                            {...params}
                            label="Modelo"
                          />
                        )}
                        sx={{ flexGrow: 1 }}
                      />
                    )}
                    <Tooltip title="Agregar Modelo">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleClickModelo()}
                      >
                        <AddBoxIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    placeholder="Patente"
                    required
                    size="small"
                    focused
                    style={style}
                    name="patente"
                    color="primary"
                    label="Patente"
                    value={datosVehiculo.patente}
                    error={error} // Indicar si hay error
                    helperText={error ? mensajeError : ""} // Mensaje de error
                    inputProps={{ maxLength: 7 }} // Máximo de 7 caracteres
                    onChange={(e) => {
                      // Convertimos a mayúsculas y eliminamos espacios
                      let inputValue = e.target.value
                        .toUpperCase()
                        .replace(/\s/g, "");

                      // Validar contra los dos formatos completos
                      const newFormat = /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/; // AB123CD
                      const oldFormat = /^[A-Z]{3}[0-9]{3}$/; // ABC123

                      // Si cumple con algún formato válido, actualiza el estado
                      if (
                        newFormat.test(inputValue) ||
                        oldFormat.test(inputValue)
                      ) {
                        setError(false); // Sin error
                        almacenar({
                          target: {
                            name: "patente",
                            value: inputValue,
                          },
                        });
                      } else {
                        setError(true); // Mostrar error
                        almacenar({
                          target: {
                            name: "patente",
                            value: inputValue,
                          },
                        });
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EightteenMpIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    label="Capacidad Tanque Combustible (lts)"
                    color="primary"
                    size="small"
                    focused
                    style={style}
                    name="ltstkcombustible"
                    type="number"
                    value={datosVehiculo.ltstkcombustible}
                    onChange={almacenar}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Lts</InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    placeholder="Capacidad (m3)"
                    size="small"
                    focused
                    name="capacidadtotalm3"
                    label="Capacidad (M3)"
                    style={style}
                    color="primary"
                    value={datosVehiculo.capacidadtotalm3}
                    onChange={(e) => {
                      setDatosVehiculo({
                        ...datosVehiculo,
                        capacidadtotalm3: e.target.value,
                        capacidad: e.target.value * 1000 * 0.52 * 0.85,
                      });
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 2,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Battery50Icon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    disabled
                    focused
                    name="capacidad"
                    size="small"
                    label="Capacidad KG (85% llenado)"
                    style={style}
                    color="primary"
                    value={datosVehiculo.capacidad}
                    onChange={almacenar}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Battery50Icon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    placeholder="Tara"
                    size="small"
                    color="primary"
                    focused
                    style={style}
                    name="tara"
                    label="Tara"
                    type="number"
                    value={datosVehiculo.tara}
                    onChange={almacenar}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FactCheckIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={4}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Autocomplete
                      disabled={
                        !choferes || tipoSeleccionado.requiere_chofer === 0
                      }
                      disableClearable
                      size="small"
                      id="choferes"
                      noOptionsText="Chofer INEXISTENTE"
                      options={choferes || []}
                      loading={!choferes}
                      autoHighlight
                      isOptionEqualToValue={(option, value) =>
                        option.id === value?.id
                      }
                      getOptionLabel={(chofer) => chofer?.nombre_apellido ?? ""}
                      value={choferSeleccionado || null}
                      onChange={(event, value) => {
                        setChoferSeleccionado(value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          style={style}
                          focused
                          size="small"
                          placeholder="Tipee para buscar..."
                          {...params}
                          label="Chofer"
                          inputProps={{
                            ...params.inputProps,
                            startAdornment: (
                              <InputAdornment position="start">
                                <TimeToLeaveIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.nombre_apellido}
                        </Box>
                      )}
                      sx={{ flexGrow: 1 }}
                    />
                    <Tooltip title="Agregar Chofer">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={handleClickchofer}
                      >
                        <AddBoxIcon />
                      </IconButton>
                    </Tooltip>{" "}
                  </Box>
                </Grid>

                <Grid item xs={4}>
                  <Autocomplete
                    disabled={!uso}
                    size="small"
                    focused
                    disableClearable
                    id="uso"
                    noOptionsText={"Uso INEXISTENTE"}
                    options={uso}
                    autoHighlight
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    getOptionLabel={(uso) => uso.valor}
                    value={usoSeleccionado || null}
                    onChange={(event, value) => {
                      setUsoSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.valor}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Uso"
                        inputProps={{
                          ...params.inputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <TimeToLeaveIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={4}>
                  <Autocomplete
                    disabled={!sucursales}
                    size="small"
                    focused
                    disableClearable
                    id="sucursal"
                    noOptionsText={"Sucursal INEXISTENTE"}
                    options={sucursales}
                    autoHighlight
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    getOptionLabel={(sucursal) => sucursal.nombre}
                    value={sucursalSeleccionada || null}
                    onChange={(event, value) => {
                      setSucursalSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Sucursal"
                        inputProps={{
                          ...params.inputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <TimeToLeaveIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!duenio}
                    size="small"
                    focused
                    disableClearable
                    id="duenio"
                    noOptionsText={"Dueño INEXISTENTE"}
                    options={duenio}
                    autoHighlight
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    getOptionLabel={(duenio) => duenio.valor}
                    value={duenioSeleccionado || null}
                    onChange={(event, value) => {
                      setDuenioSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.valor}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Dueño"
                        inputProps={{
                          ...params.inputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <TimeToLeaveIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!transportistas}
                    size="small"
                    focused
                    disableClearable
                    id="transportista"
                    noOptionsText={"Transportista INEXISTENTE"}
                    options={transportistas}
                    autoHighlight
                    isOptionEqualToValue={(option, value) =>
                      option.id_transportista === value?.id_transportista
                    }
                    getOptionLabel={(transportista) => transportista.nombre}
                    value={transportistaSeleccionada || null}
                    onChange={(event, value) => {
                      setTransportistaSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id_transportista}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Transportista"
                        inputProps={{
                          ...params.inputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <TimeToLeaveIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!tipoVehiculo || tipoVehiculo.length === 0}
                    options={tipoVehiculo || []}
                    loading={tipoVehiculo || []}
                    size="small"
                    focused
                    disableClearable
                    id="tipoVehiculo"
                    noOptionsText={"Tipo INEXISTENTE"}
                    getOptionLabel={(tipo) => tipo?.nombre ?? ""}
                    autoHighlight
                    value={tipoSeleccionado || null}
                    onChange={(event, value) => {
                      setTipoSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nombre}
                      </Box>
                    )}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <TimeToLeaveIcon />
                        </InputAdornment>
                      ),
                    }}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Tipo"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={1.5}>
                  <FormControlLabel
                    disabled={
                      !(
                        tipoSeleccionado &&
                        usoSeleccionado &&
                        tipoSeleccionado.es_t1 === 1 &&
                        usoSeleccionado.id === 66
                      )
                    }
                    checked={datosVehiculo.t1 === 1}
                    onChange={(e) =>
                      setDatosVehiculo({
                        ...datosVehiculo,
                        ["t1"]: e.target.checked ? 1 : 0,
                      })
                    }
                    control={
                      <Checkbox
                        sx={{
                          transform: "scale(1.25)",
                          position: "relative",
                          zIndex: 1,
                        }}
                      />
                    }
                    label="Es T1"
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    placeholder="N° Motor"
                    color="primary"
                    focused
                    size="small"
                    style={style}
                    name="nro_motor"
                    label="N° Motor"
                    type="text"
                    value={datosVehiculo.nro_motor}
                    onChange={almacenar}
                    inputProps={{
                      maxLength: 40,
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    placeholder="N° Chasis"
                    color="primary"
                    focused
                    size="small"
                    style={style}
                    name="nro_chasis"
                    label="N° Chasis"
                    type="text"
                    value={datosVehiculo.nro_chasis}
                    onChange={almacenar}
                    inputProps={{
                      maxLength: 40,
                    }}
                  />
                </Grid>
              </Grid>

              <fieldset
                style={{
                  border: "1px solid #1976d2",
                  borderRadius: "8px",
                  padding: "16px",
                }}
              >
                <legend
                  style={{
                    padding: "0 8px",
                    fontWeight: "bold",
                    color: "#1976d2",
                  }}
                >
                  VENCIMIENTOS
                </legend>

                {/* MAPEO */}
                <Grid container spacing={2}>
                  {componentes.length > 0 ? (
                    componentes.map((comp) => {
                      const keyBase = comp.componente
                        .toLowerCase()
                        .replace(/\s+/g, "_");
                      const fieldName = `vencimiento_${keyBase}`;

                      // busca vencimiento existente para ese componente
                      const match = vencimientos.find(
                        (v) =>
                          Number(v.id_componente) === Number(comp.id_componente)
                      );

                      console.log("match", match);
                      

                      const fechaFromDatos = datosVehiculo?.[fieldName];
                      const fechaFromMatch =
                        match?.vencimiento ?? match?.fecha_vencimiento ?? null;
                      const fechaRaw =
                        datosVehiculo &&
                        Object.prototype.hasOwnProperty.call(
                          datosVehiculo,
                          fieldName
                        )
                          ? fechaFromDatos
                          : fechaFromMatch;

                      const fieldValue = fechaRaw
                        ? moment(fechaRaw).format("YYYY-MM-DD")
                        : "";

                      return (
                        <Grid item xs={12} sm={4} key={comp.id_componente}>
                          <Box
                            sx={{
                              backgroundColor: "#ffffffcc",
                              borderRadius: 2,
                              p: 2,
                              boxShadow: 1,
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{ marginTop: -1, color: "#1976D2" }}
                            >
                              <b>{comp.componente}</b>
                            </Typography>

                            <Grid container direction="column" spacing={2}>
                              <Grid item>
                                <TextField
                                  fullWidth
                                  size="small"
                                  focused
                                  color="primary"
                                  label="Fecha Vto."
                                  name={fieldName}
                                  type="date"
                                  onChange={almacenar}
                                  value={fieldValue}
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                      );
                    })
                  ) : (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          backgroundColor: "#ffffffcc",
                          borderRadius: 2,
                          p: 2,
                          boxShadow: 1,
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ color: "#1976D2" }}
                        >
                          <b>Sin Componentes</b>
                        </Typography>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </fieldset>

              <Grid
                mt={2}
                container
                direction="row"
                justifyContent="space-between"
                alignItemns="center"
              >
                <Button variant="contained" onClick={handleClose} color="error">
                  Volver
                </Button>
                <Button
                  variant="contained"
                  disabled={disBtn}
                  type="submit"
                  color="success"
                >
                  Guardar Vehiculo
                </Button>
              </Grid>
            </Box>
          </form>
          <br />
        </Container>
      ) : null}

      {altaMarca ? (
        <AddMarcaVehiculo alta={setAltaMarca} tabla={setTabla} />
      ) : null}

      {altaModelo ? (
        <AddModeloVehiculo alta={setAltaModelo} tabla={setTabla} />
      ) : null}

      {altachofer ? ( //llamar al form Addchofer en la misma ruta
        <Addchofer
          alta={setAltachofer}
          tabla={setTabla}
          setActualizar={setActualizar}
        />
      ) : null}

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={autoHide}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            sx={{ width: "100%" }}
            style={{
              backgroundColor: colormensaje,
              color: severity === "error" ? "#6b0b14" : "#000",
              fontWeight: 500,
            }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default Editarvehiculos;
